import React, { Component, PureComponent } from 'react'
import PropTypes from 'prop-types'


import { connect } from 'react-redux'


import {
  setMainPanelContent,
  setViewedRoute,
  rewriteHeadsign,
  setViewedTrip,
  calcRemainingHeight
} from '../../actions/ui'
import { setActiveItinerary } from '../../actions/narrative'
import {findRoutes, findRoute,findPatternsForRoute} from '../../actions/api'
import TripViewer from '../viewers/trip-viewer'
import Box from '@mui/material/Box';
import Typography from "@mui/material/Typography";
import FormControlLabel from '@mui/material/FormControlLabel';
import { setMarkers} from '../../actions/config'
import i18n from "../../../i18nSetup";

/*function operatorIndexForRoute (operators, route) {
  if (!route.agency) return 0
  const index = operators.findIndex(o =>
    o.id.toLowerCase() === route.agency.id.split(':')[0].toLowerCase())
  if (index !== -1 && typeof operators[index].order !== 'undefined') return operators[index].order
  else return 0
}*/

/**
 * Determine the appropriate contrast color for text (white or black) based on
 * the input hex string (e.g., '#ff00ff') value.
 *
 * From https://stackoverflow.com/a/11868398/915811
 *
 * TODO: Move to @opentripplanner/core-utils once otp-rr uses otp-ui library.
 */
/*function getContrastYIQ (hexcolor) {
  hexcolor = hexcolor.replace('#', '')
  const r = parseInt(hexcolor.substr(0, 2), 16)
  const g = parseInt(hexcolor.substr(2, 2), 16)
  const b = parseInt(hexcolor.substr(4, 2), 16)
  const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000
  return (yiq >= 128) ? '000000' : 'ffffff'
}*/

class RouteViewer extends Component {
  static propTypes = {
    hideBackButton: PropTypes.bool,
    routes: PropTypes.object,
    routeResults:PropTypes.array
  }

 // _backClicked = () => this.props.setMainPanelContent(null)

  componentDidMount () {
  }

  render () {
    const {
      findRoute,
      findPatternsForRoute,
      routes,
      routeResults,
      setViewedRoute,
      setActiveItinerary,
      viewedRoute,
      setMarkers
    } = this.props

    setMarkers(0);
   /* const sortedRoutes = routes
        ? Object.values(routes).sort(routeComparator)
        : []
    const agencySortedRoutes = operators.length > 0
        ? sortedRoutes.sort((a, b) => {
          return operatorIndexForRoute(operators, a) - operatorIndexForRoute(operators, b)
        })
        : sortedRoutes*/
    if (viewedRoute && routes && routes[viewedRoute.routeId] && viewedRoute.pattern && routes[viewedRoute.routeId].patterns && routes[viewedRoute.routeId].patterns[viewedRoute.pattern]) {
      setMarkers(1);
      return <TripViewer/>
    }

    return (
        <div id={'route-viewer-body'}>
          {!viewedRoute && <div className='route-viewer'>
          <div className='route-viewer-body'>
            <Box sx={{width: '100%', overflow: 'auto',
              maxHeight: calcRemainingHeight('search-screen')}}>
              {routeResults && routeResults
                .map(route => {
                  // Find operator based on agency_id (extracted from OTP route ID).
                  // TODO: re-implement multi-agency logos for route viewer.
                  // const operator = operatorForRoute(operators, route) || {}
                  return (
                    <RouteRow
                      findRoute={findRoute}
                      findPatternsForRoute={findPatternsForRoute}
                      isActive={viewedRoute && viewedRoute.routeId === route.id}
                      key={route.id}
                      pattern={route.id}
                      headsign={ rewriteHeadsign(route.headsign)}
                      // operator={operator}
                      route={route}
                      originStop={route.originStop}
                      setViewedRoute={setViewedRoute}
                      setActiveItinerary={setActiveItinerary}
                      locale={this.props.locale}
                      agencyFilter = {this.props.agencyFilter}
                    />
                  )
                })
              }
            </Box>

          </div>
          </div>}
          {/*
        {viewedRoute && viewedRoute.routeId && viewedRoute.pattern && routes[viewedRoute.pattern].patterns &&  <TripViewer /> }
*/}
        </div>

    )
  }
}

class RouteRow extends PureComponent {
  _onClick = (e) => {
    e && e.preventDefault();
    const { findRoute, isActive, setViewedRoute,pattern,locale, agencyFilter,setActiveItinerary,headsign,findPatternsForRoute } = this.props
    if (isActive) {
      // Deselect current route if active.
      setViewedRoute({ routeId: null,pattern:null })
    } else {
      // Otherwise, set active and fetch route patterns.
      let route = this.props.route;
      if(route && route.route){
          route = route.route; // match busnearby response
  
      }
     // setViewedTrip(null)
      setActiveItinerary(null)
     // findRoute({ routeId: route.id,pattern }, locale, agencyFilter)  // have redundant step
     findPatternsForRoute({ routeId: route.id,patternId:pattern }, locale, agencyFilter) 

      setViewedRoute({ routeId: route.id,pattern,route,headsign })
    }
  }

  render () {
    const {isActive,operator, headsign,pattern} = this.props
    let route = this.props.route;
    if(route && route.route){
        route = route.route; // match busnearby response

    }
    if(!route)
      return null;
    const {defaultRouteColor, longNameSplitter} = operator || {}
    const backgroundColor = `#${defaultRouteColor || route.color || '000'}`
    // NOTE: text color is not a part of short response route object, so there
    // is no way to determine from OTP what the text color should be if the
    // background color is, say, black. Instead, determine the appropriate
    // contrast color and use that if no text color is available.
   // const contrastColor = getContrastYIQ(backgroundColor)
    const color =  `#${route.textColor || 'FFFFFF'}`
    // Default long name is empty string (long name is an optional GTFS value).
    let longName = ''
    if (route.longName) {
      // Attempt to split route name if splitter is defined for operator (to
      // remove short name value from start of long name value).
      const nameParts = route.longName.split(longNameSplitter)
      longName = (longNameSplitter && nameParts.length > 1)
        ? nameParts[1]
        : route.longName
      // If long name and short name are identical, set long name to be an empty
      // string.
      if (longName === route.shortName) longName = ''
    }
    let origin = '';
    if(this.props.route.origin_stop_name){

      origin = this.props.route.origin_stop_name;
      if(this.props.route.origin_city && !origin.includes(this.props.route.origin_city)){
        origin += ", " + this.props.route.origin_city;
      }


    }else if(this.props.route && this.props.route.originStop){
      let originStop = this.props.route.originStop;
      origin = originStop.name || '';
      if(originStop.city && !origin.includes(originStop.city)){
        origin += ", " + originStop.city;
      }
    }

    if(route.motAlternative && route.motAlternative != '0' && route.motAlternative != '#'){
        origin += ' (' + route.motAlternative + ')'
    }else  if(this.props.route.motAlternative && this.props.route.motAlternative != '0' && this.props.route.motAlternative != '#'){
      origin += ' (' + this.props.route.motAlternative + ')'
  }

    let appendix = "";

    if(715 == route.type){
      appendix += i18n.t("ADVANCED_BOOKING_REQUIRED");
    }

    return (
      <a href={"/route/" + pattern}
      onClick={this._onClick} style={{textDecoration: 'none'}}>
        <div 
             style={{padding:8,display:'flex',alignItems:'center',borderBottom: '1px solid lightgray',}}>
                <Box fontWeight="fontWeightBold" pr={1} pl={1} sx={{textAlign:'center',verticalAlign:'center',
                  backgroundColor: backgroundColor === '#ffffff' ? 'rgba(0,0,0,0)' : backgroundColor,
                  color,
                  borderRadius: '2px',
                }}>
                  {route.shortName}
                </Box>
          <div style={{marginInlineStart:'12px',display:'flex',flexDirection:'column'}}>
          <Typography sx={{color:'black',display:'inline-block',fontWeight:'400',fontSize:16,lineHeight:'unset'}}>{i18n.t('toDirect')} {rewriteHeadsign(headsign) + appendix}</Typography>
          <Typography sx={{display:'inline-block',color:'grey',fontSize:14,lineHeight:'unset'}}>{i18n.t('departureStop')}{origin}</Typography>
          </div>
        </div>
      </a>
    )
  }
}
// connect to redux store

const mapStateToProps = (state, ownProps) => {
  return {
    operators: state.otp.config.operators,
    routeResults: state.otp.transitIndex.routesArray,
    routes: state.otp.transitIndex.routes,
    viewedRoute: state.otp.ui.viewedRoute,
    locale:state.otp.currentQuery.locale,
    agencyFilter:state.otp.currentQuery.agencyFilter
  }
}

const mapDispatchToProps = {
  findRoute,
  findRoutes,
  findPatternsForRoute,
  setMainPanelContent,
  setViewedRoute,
  setViewedTrip,
  setActiveItinerary,
  setMarkers
}

export default connect(mapStateToProps, mapDispatchToProps)(RouteViewer)
